import pino from "pino";
import { noticeError } from "./newrelic/requests";

const logLevel = process.env.LOG_LEVEL || "info";
export type PinoLogLevels =
  | "trace"
  | "debug"
  | "info"
  | "warn"
  | "error"
  | "fatal";

const pinoLogger = pino({
  level: logLevel,
  formatters: {
    level(label) {
      return { level: label };
    },
  },
});

const isServer = typeof window === "undefined";

export const logger = (
  level: PinoLogLevels,
  message: string,
  error?: unknown,
  options?: { [key: string]: string },
) => {
  if (isServer) {
    const messagePlusOptionalOptions = `${message} ${options ? `| ${JSON.stringify(options)}` : ""}`;
    if (error) {
      pinoLogger[level](error, messagePlusOptionalOptions);
    } else {
      pinoLogger[level](messagePlusOptionalOptions);
    }
  } else {
    noticeError(message, options);
  }
};
